export const SORT_PLAYLISTS = "Content/SORT_PLAYLISTS"


export const sortPlaylists = sortSource => ({
    type: SORT_PLAYLISTS,
    payload: sortSource
})
